module.exports = __webpack_public_path__ + "img/reward-success-light.026bb26c.png";